// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.

import { IInvitationStatusEnumDto } from './invitation-status-enum-dto.g';

export const invitationDto = {
    guid: 'guid',
    email: 'email',
    status: 'status',
    isExpired: 'isExpired',
    expiresOn: 'expiresOn',
    invitedBy_Name: 'invitedBy_Name',
    acceptedUser_Name: 'acceptedUser_Name',
    acceptedOn: 'acceptedOn',
    approvedOn: 'approvedOn',
    acceptedUser_TwoFactorMissing: 'acceptedUser_TwoFactorMissing',
    createdOn: 'createdOn',
    timeStamp: 'timeStamp',
} as const;

export type TInvitationDto = (typeof invitationDto)[keyof typeof invitationDto];

export const invitationDtoConstraints = {
    email: { required: true },
} as const;

export type TInvitationDtoConstraints = typeof invitationDtoConstraints;

export interface IInvitationDto {
    [invitationDto.guid]: string | null;
    [invitationDto.email]: string | null;
    [invitationDto.status]: IInvitationStatusEnumDto | null;
    [invitationDto.isExpired]: boolean | null;
    [invitationDto.expiresOn]: string | null;
    [invitationDto.invitedBy_Name]: string | null;
    [invitationDto.acceptedUser_Name]: string | null;
    [invitationDto.acceptedOn]: string | null;
    [invitationDto.approvedOn]: string | null;
    [invitationDto.acceptedUser_TwoFactorMissing]: boolean | null;
    [invitationDto.createdOn]: string | null;
    [invitationDto.timeStamp]: string | null;
}

export class InvitationDto
    implements IInvitationDto
{
    [invitationDto.guid]: string | null = null;
    [invitationDto.email]: string | null = null;
    [invitationDto.status]: IInvitationStatusEnumDto | null = null;
    [invitationDto.isExpired]: boolean | null = null;
    [invitationDto.expiresOn]: string | null = null;
    [invitationDto.invitedBy_Name]: string | null = null;
    [invitationDto.acceptedUser_Name]: string | null = null;
    [invitationDto.acceptedOn]: string | null = null;
    [invitationDto.approvedOn]: string | null = null;
    [invitationDto.acceptedUser_TwoFactorMissing]: boolean | null = null;
    [invitationDto.createdOn]: string | null = null;
    [invitationDto.timeStamp]: string | null = null;

    private constructor(
        modelData: any, // TODO: vervang door IInvitationData
    ) {
        // TODO: map van modelData naar DTO properties
        // Voorbeeld: this[invitationDto.guid] = modelData[invitationData.guid];
    }

    static create(modelData?: any | null): IInvitationDto | null {
        return modelData ? new InvitationDto(modelData) : null;
    }
}
